import instance from 'api';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IDivision, IRealEstate } from './interfaces';

export const getDivisionList = (data: IDynamicTableParams) => {
  return instance()
    .post<IDivision[]>('/division/list', data)
    .then((response) => response.data);
};

export const getDivisionListAll = () => {
  return instance()
    .post<IDivision[]>('/division/listAll')
    .then((response) => response.data);
};

export const getDivisionAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/division/availableColumns')
    .then((response) => response.data);
};

export const getDivisionAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/division/availableGroupColumns')
    .then((response) => response.data);
};

export const loadDivision = (divisionId: number) => {
  return instance()
    .get<IDivision>(`/division/load/${divisionId}`)
    .then((response) => response.data);
};

export const createDivision = (division: IDivision) => {
  return instance()
    .post<IDivision>(`/division/save`, division)
    .then((response) => response.data);
};

export const updateDivision = (divisionId: number, division: IDivision) => {
  return instance()
    .post<IDivision>(`/division/${divisionId}/update`, division)
    .then((response) => response.data);
};

export const archiveDivision = (divisionId: number) => {
  return instance()
    .post(`/division/archive`, { divisionId })
    .then((response) => response.data);
};

export const recoverDivision = (divisionId: number) => {
  return instance()
    .post(`/division/recover`, { divisionId })
    .then((response) => response.data);
};

export const getRealEstatesShort = (
  data: { searchWithCity?: boolean; nameWithCity?: boolean } = {
    searchWithCity: true,
    nameWithCity: true,
  },
) => {
  return instance()
    .post<IRealEstate[]>('/dictionary/realEstatesShort', data)
    .then((response) => response.data);
};
